"use client";

import { useEffect } from "react";
import { useBrandLogoVariant } from "@/components/brand/logo-context";
import { getBrandIconHref } from "@/lib/brand/logo-variant";

const LINK_ATTR = "data-brand-favicon";

/** Синхронизирует favicon с выбранным лого без жёсткого кэша браузера. */
export function BrandFavicon() {
  const variant = useBrandLogoVariant();

  useEffect(() => {
    const href = getBrandIconHref(variant);
    const selector = `link[${LINK_ATTR}]`;
    let link = document.head.querySelector<HTMLLinkElement>(selector);
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      link.setAttribute("type", "image/svg+xml");
      link.setAttribute(LINK_ATTR, "1");
      document.head.appendChild(link);
    }
    link.href = href;

    // Подменяем стандартные icon-ссылки Next, чтобы вкладка не держала старый знак.
    document.head
      .querySelectorAll<HTMLLinkElement>("link[rel='icon'], link[rel='shortcut icon']")
      .forEach((el) => {
        if (el.getAttribute(LINK_ATTR)) return;
        el.href = href;
      });
  }, [variant]);

  return null;
}
